import BaseAPI from './base/base-api';

class AccessLogAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'ManagementAPI';
    controllerName = 'accesslog';
}

export default new AccessLogAPI();